module.exports = __webpack_public_path__ + "img/logo serdex.c158009d.png";